import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import Pagination from "./Pagination";

const TH = ["Customer", "Email", "Plan", "Amount / mo", "Interval", "Period End", "Started"];

function SkeletonRows() {
  return Array.from({ length: 6 }).map((_, i) => (
    <tr key={i}>
      {TH.map((_, j) => (
        <td key={j} className="sales-table-td" style={{ padding: "13px 14px" }}>
          <div className="stripe-skeleton" style={{ height: 13, borderRadius: 4, width: j === 0 ? "70%" : j === 1 ? "90%" : "60%" }} />
        </td>
      ))}
    </tr>
  ));
}

export default function SubscriptionsTab() {
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [cursorStack, setCursorStack] = useState([]);
  const [page, setPage] = useState(1);

  const fetchPage = useCallback((cursor) => {
    setLoading(true);
    let url = "/api/stripe/subscriptions/active?limit=50";
    if (cursor) url += `&starting_after=${cursor}`;
    axios
      .get(url)
      .then((res) => {
        if (res.data.success) {
          setSubs(res.data.data);
          setHasMore(res.data.hasMore);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { fetchPage(undefined); }, [fetchPage]);

  const handleNext = () => {
    const lastId = subs[subs.length - 1]?.id;
    if (!lastId) return;
    setCursorStack((p) => [...p, lastId]);
    setPage((p) => p + 1);
    fetchPage(lastId);
  };

  const handlePrev = () => {
    const newStack = cursorStack.slice(0, -1);
    setCursorStack(newStack);
    setPage((p) => p - 1);
    fetchPage(newStack[newStack.length - 1]);
  };

  return (
    <div className="stripe-section-card">
      <div className="stripe-section-header">
        <div>
          <span className="stripe-section-title">Active Subscriptions</span>
          {!loading && <span className="stripe-section-count">{subs.length} on this page</span>}
        </div>
      </div>

      <div className="scroll-x-container" style={{ border: "none", borderRadius: 0 }}>
        <div className="sales-table-wrap">
          <table className="sales-table">
            <thead>
              <tr>
                {TH.map((h) => <th key={h}>{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <SkeletonRows />
              ) : subs.length === 0 ? (
                <tr>
                  <td colSpan={TH.length}>
                    <div className="stripe-empty">
                      <div className="stripe-empty-icon">💳</div>
                      No active subscriptions found
                    </div>
                  </td>
                </tr>
              ) : (
                subs.map((s) => (
                  <tr key={s.id}>
                    <td style={{ fontWeight: 700 }}>{s.customerName}</td>
                    <td style={{ color: "#6b7280" }}>{s.customerEmail || "—"}</td>
                    <td>{s.planName}</td>
                    <td>
                      <span style={{ fontWeight: 800, color: "#22c55e" }}>
                        ${s.amount.toFixed(2)}
                      </span>
                    </td>
                    <td>
                      <span className="stripe-badge" style={{ background: "#eff6ff", color: "#3b82f6" }}>
                        {s.interval}
                      </span>
                    </td>
                    <td style={{ color: "#6b7280" }}>
                      {s.currentPeriodEnd ? new Date(s.currentPeriodEnd * 1000).toLocaleDateString() : "—"}
                    </td>
                    <td style={{ color: "#6b7280" }}>
                      {s.createdAt ? new Date(s.createdAt * 1000).toLocaleDateString() : "—"}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <Pagination
        page={page}
        hasMore={hasMore}
        onPrev={handlePrev}
        onNext={handleNext}
        loading={loading}
      />
    </div>
  );
}
